import { NavLink } from 'react-router-dom'
import { AnalogClock } from '@/components/analog-clock'
import { CommandPalette } from '@/components/command-palette'
import { Magnetic } from '@/components/magnetic'
import { MobileMenu } from '@/components/mobile-menu'
import { ThemeToggle } from '@/components/theme-toggle'
import { cn } from '@/lib/utils'

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/what-we-do', label: 'What We Do' },
  { to: '/contact', label: 'Contact' },
]

// A solid pill, not a frosted/blurred one -- the glass look reads as a
// generic AI-site tell, and a plain opaque surface actually holds up
// better over the busier hero content underneath. "What We Do" gets its
// own outline pill next to Get Started instead of sitting as a plain text
// link -- it was getting lost between the logo and the icon cluster.
export function SiteHeader() {
  return (
    <header className="sticky top-4 z-20 px-4 min-[900px]:top-6 min-[900px]:px-8">
      <nav className="mx-auto flex min-h-14 max-w-[1400px] items-center justify-between gap-4 rounded-full border border-n-200 bg-n-300 px-5">
        <Magnetic strength={0.25}>
          <NavLink
            to="/"
            data-cursor="link"
            className="font-display text-[26px] italic tracking-[-0.01em] text-ink transition-colors hover:text-flow"
          >
            Flowscale
          </NavLink>
        </Magnetic>
        <div className="flex items-center gap-1 min-[900px]:gap-2">
          <div className="hidden items-center gap-6 pr-2 min-[700px]:flex">
            {NAV_LINKS.filter((link) => link.to !== '/what-we-do').map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                data-cursor="link"
                className={({ isActive }) =>
                  // text-flow-lo, not text-flow, for this persistent (non-hover)
                  // normal-size state -- the base accent color is only ~3.8:1
                  // against the light-theme canvas, under the 4.5:1 WCAG AA
                  // floor for body-size text. accent-lo clears it in both
                  // themes (~6:1) without needing a new token.
                  cn('text-body transition-colors', isActive ? 'text-flow-lo' : 'text-n-500 hover:text-ink')
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
          <CommandPalette />
          <ThemeToggle />
          <div className="min-[700px]:hidden">
            <AnalogClock />
          </div>
          <MobileMenu links={NAV_LINKS} />
          <Magnetic strength={0.35} className="hidden min-[700px]:block">
            <NavLink
              to="/what-we-do"
              data-cursor="link"
              className={({ isActive }) =>
                cn(
                  'ml-1 inline-flex min-h-11 items-center justify-center rounded-full border px-6 text-body font-medium transition-colors',
                  isActive
                    ? 'border-flow text-flow-lo'
                    : 'border-n-200 text-ink hover:border-flow hover:text-flow',
                )
              }
            >
              What We Do
            </NavLink>
          </Magnetic>
          <Magnetic strength={0.4} className="hidden min-[700px]:block">
            <NavLink
              to="/contact"
              data-cursor="link"
              className="inline-flex min-h-11 items-center justify-center rounded-full bg-flow px-6 text-body font-medium text-n-100 transition-colors hover:bg-flow-hi"
            >
              Get Started
            </NavLink>
          </Magnetic>
        </div>
      </nav>
    </header>
  )
}
